import { Checkin } from '../models/checkin';

export class Template extends Checkin {

}



// WEBPACK FOOTER //
// ./src/models/template.ts